import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
//*MUI
import { Box, Modal } from "@mui/material";
//*files
import cssClasses from "./AssignNewToken.module.css";
import Close from "../../Components/Icons/Close";
//subComponent
import CustomInput from "../../Subcomponents/CustomInput";
import Button from "../../Subcomponents/Button";
import DateComponent from "../../Subcomponents/DateComponent";
import DropDown from "../../Subcomponents/DropDown";
import CustomRadio from "../../Subcomponents/CustomRadio";
import RupeeIcon from "../../Assets/Images/Sustenance/RupeeIcon.svg";
import PinIcon from "../../Assets/Images/Sustenance/pinIcon.svg";
import { Card } from "@mui/material";
//
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";

import { useSelector } from "react-redux";
//service
import {
  getAllEvents,
  getEventToken,
  assignNewToken,
  updateLeadStatus,
  TokenTransactions,
  getAssignedToken,
  getAllFutureEvents,
  getPreSelectInventory,
  checkForPerquisiteToken,
  updateEventLeadTokenGroup,
  updateTokenTransaction,
  assignNewTokenThroughPaymentTab,
  getEventTokenLeadRelations,
  getLinkedTokenDetails
} from "../../Services/AssignNewToken";

import { errorTost, offlineToast, successTost } from "../../Services/Toast";
import { dismissLoader, presentLoader } from "../../Services/loader";
import { createPaymentLink } from "../../Services/PaymentApi";
import { PairedUnitBlock } from "../../Subcomponents/FloorComponent/FloorComponents";
import { useNavigate } from "react-router-dom";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import Dot from "../../Components/Icons/Dot";
import { Network } from "@capacitor/network";
import { sendMailTo, sendMessage } from "../../Services/SmsService";
import {
  addLeadLogs,
  checkLeadSiteVisitAndProjects,
  getLaunchesProjects,
  sendWhatsappMessageOnAssignToken,
  updateLeadAllStatus,
} from "../../Services/Lead";
import {
  getEventLaunch,
  getEventLaunchAssignToken,
} from "../../Services/Event";
import { orderBy, uniqBy } from "lodash";
import RefundToken from "../RefundToken/RefundToken";
import SelectPreferredLocation from "../SelectPreferredLocation/SelectPreferredLocation";
import {
  checkTagLaunchesByLaunchId,
  getLaunchSalesRelationsById,
} from "../../Services/EventTokens";
const useStyles = makeStyles((theme) => ({
  tokenName: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "2rem",
    lineHeight: "3rem",
    color: "#000000",
  },
  wrapperIcons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-around",
    marginBottom: "2rem",
    position: "relative",
  },
  closeIcon: {
    cursor: "pointer",
    position: "absolute",
    right: "1.7rem",
    top: "1.7rem",
  },
  title: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.8rem",
    lineHeight: "2.8rem",
    color: "#101828",
    marginBottom: "0.8rem",
  },
  subTitle: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  labelCard: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  labelValue: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  wrapperButtons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    columnGap: "1.2rem",
  },
  backArrow: {
    verticalAlign: "middle",
  },
}));

export default function AssignNewToken({
  open,
  handleClose,
  returnRes,
  data,
  oldTokenData,
}) {
  console.log("AssignNewToken Modal called with data and oldTokenData", data, oldTokenData);
  const navigate = useNavigate();
  const classes = useStyles();
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  console.log(data);
  const [EventList, setEventList] = useState([]);
  const [assignTokenData, setAssignTokenData] = useState({
    event: "",
    selectedEventToken: null,
    paymentMethod: "",
    differenceInTokenAmount: null,
    preferredLocation: "",
    preferredUnitType: "",
  });
  const [locationList, setLocationList] = useState([]);
  const [selectPreferredLocationModal, setSelectPreferredLocationModal] =
    useState(false);
  const [unitTypeList, setUnitTypeList] = useState([]);
  const [selectPreferredUnitTypeModal, setSelectPreferredUnitTypeModal] =
    useState(false);

  const [helperText, setHelperText] = useState({
    type: "",
    paymentMethod: "",
    upiUrl: "",
  });
  const [showNoTokens, setShowNoTokens] = useState(false);
  const [tokenInfo, setTokenInfo] = useState([]);
  const [AlreadydyHaveTokenInfo, setAlreadyHaveTokenInfo] = useState([]);
  const [tokenCount, setTokenCount] = useState(0);
  const [nextCount, setNextCount] = useState(0);
  const [refundTokenData, setRefundTokenData] = useState(null);
  // const [isPreSelectPresent,setIsPreselectPresent]=useState(false);
  const [refundTokenModal, setRefundTokenModal] = useState(false);
  const [linkedTokenData, setLinkedTokenData] = useState(null);
  const [linkedToken, setLinkedToken] = useState(false);
  const [showErrorText, setShowErrorText] = useState({
    value: false,
    errorText: "",
  });

  useEffect(() => {
    console.log({ oldTokenData }, { data });

    Network.getStatus().then((status) => {
      if (status.connected) {
        getEventLaunchAssignToken(loggedInUser.userId, loggedInUser).then(
          (launchSalesRelationRes) => {
            dismissLoader();
            console.log({ launchSalesRelationRes });
            let eventArr = [];
            launchSalesRelationRes.data.forEach((el) => {
              eventArr.push(el.launchId.eventId);
            });
            let newArr = [];
            // resp.data=resp.data.filter(({allowTokenBuyingInEvent})=>allowTokenBuyingInEvent===true)
            uniqBy(eventArr, "eventId").forEach((el) => {
              // ??live event
              if (
                el.startDateTime < Date.now() &&
                el.endDateTime > Date.now() &&
                el.isPublished
              ) {
                if (el.allowTokenBuyingInEvent) {
                  newArr.push(el);
                }
              }
              // ??Upcoming event
              else if (
                el.startDateTime > Date.now() &&
                el.endDateTime > Date.now() &&
                el.isPublished
              ) {
                newArr.push(el);
              }
            });

            setEventList([...newArr]);
          }
        );
        // getAllFutureEvents()
        //   .then((resp) => {
        //     console.log(resp);
        //     let newArr = [];
        //     // resp.data=resp.data.filter(({allowTokenBuyingInEvent})=>allowTokenBuyingInEvent===true)
        //     resp.data.forEach((el) => {
        //       // ??live event
        //       if (el.startDateTime < Date.now() && el.endDateTime > Date.now()) {
        //         if (el.allowTokenBuyingInEvent) {
        //           newArr.push(el);
        //         }
        //       }
        //       // ??Upcoming event
        //       else if (
        //         el.startDateTime > Date.now() &&
        //         el.endDateTime > Date.now()
        //       ) {
        //         newArr.push(el);
        //       }
        //     });
        //     setEventList([...newArr]);
        //   })
        //   .catch((err) => {
        //     console.log(err);
        //   });
      } else {
        offlineToast();
      }
    });
    if (oldTokenData) {
      getLinkedTokenData();
    }
  }, []);
  useEffect(() => {
    console.log({ linkedTokenData });
  }, [linkedTokenData]);

  function getLinkedTokenData() {
    getLinkedTokenDetails(
      oldTokenData?.eventid,
      oldTokenData?.paymentid,
      oldTokenData?.leadid
    )
      .then((response) => {
        console.log({ response });
        if (response.length > 0) {
          setLinkedTokenData(response[0]);
          setLinkedToken(true);
        } else {
          let obj = {
            paidAmount: 0,
          };
          setLinkedTokenData(obj);
          setLinkedToken(false);
        }
      })
      .catch((err) => {
        console.log("error while getting event");
      });
  }
  function numberWithCommas(x) {
    return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ",");
  }

  function validateFirstNext() {
    var form = true;
    if (assignTokenData.event === "") {
      form = false;
      setHelperText((preValue) => {
        preValue.event = "Please select Event";
        return { ...preValue };
      });
    }
    if (assignTokenData.event !== "") {
      if (assignTokenData.selectedEventToken === null) {
        form = false;
        errorTost("Please Select token");
      } else if (
        assignTokenData.selectedEventToken?.tokenId?.isLocationEnabled &&
        !assignTokenData.preferredLocation
      ) {
        form = false;
        errorTost("Please select preferred location");
      } else if (
        assignTokenData.selectedEventToken?.tokenId?.isUnitTypeEnabled &&
        !assignTokenData.preferredUnitType
      ) {
        form = false;
        errorTost("Please select unit type");
      }
    }

    return {
      flag: form,
    };
  }
  function checkAllFieldsAreFilled() {
    let flag = validateFirstNext();
    console.log({ assignTokenData });
    if (flag.flag) {
      if (assignTokenData?.selectedEventToken?.tokenId?.isPreselect) {
        // **check for prequiste token
        if (assignTokenData?.selectedEventToken?.prerequisiteId !== null) {
          checkForPerquisiteToken(
            assignTokenData?.selectedEventToken.prerequisiteId.eventTokenId,
            data.leadId
          )
            .then((eachToken) => {
              console.log("eachToken", eachToken);
              if (eachToken.length === 0) {
                errorTost(
                  `First, buy ${assignTokenData?.selectedEventToken.prerequisiteId.tokenId.name} for ${assignTokenData?.selectedEventToken.tokenId.name}!`
                );
                // errorTost(`First, buy ${assignTokenData?.selectedEventToken.prerequisiteId.tokenId.name} to buy ${assignTokenData?.selectedEventToken.tokenId.name}!`)
              } else {
                sessionStorage.setItem("isEventLive", JSON.stringify(true));
                navigate(
                  `/home/Event/Details/${assignTokenData?.selectedEventToken?.eventId}/DirectAllotment`
                );
                sessionStorage.setItem(
                  "GlobalLeadPreSelected",
                  JSON.stringify(true)
                );
                sessionStorage.setItem(
                  "GlobalLeadPreSelectedLeadData",
                  JSON.stringify({ ...data, ...assignTokenData })
                );
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          sessionStorage.setItem("isEventLive", JSON.stringify(true));
          navigate(
            `/home/Event/Details/${assignTokenData?.selectedEventToken?.eventId}/DirectAllotment`
          );
          sessionStorage.setItem("GlobalLeadPreSelected", JSON.stringify(true));
          sessionStorage.setItem(
            "GlobalLeadPreSelectedLeadData",
            JSON.stringify({ ...data, ...assignTokenData })
          );
        }
      } else {
        // setNextCount(nextCount + 1);
        if (assignTokenData?.selectedEventToken?.prerequisiteId !== null) {
          checkForPerquisiteToken(
            assignTokenData?.selectedEventToken.prerequisiteId.eventTokenId,
            data.leadId
          )
            .then((eachToken) => {
              console.log(eachToken);
              if (eachToken.length === 0) {
                errorTost(
                  `First, buy ${assignTokenData?.selectedEventToken.prerequisiteId.tokenId.name} for ${assignTokenData?.selectedEventToken.tokenId.name}!`
                );
                // errorTost(`First, buy ${assignTokenData?.selectedEventToken.prerequisiteId.tokenId.name} to buy ${assignTokenData?.selectedEventToken.tokenId.name}!`)
              } else {
                setNextCount(nextCount + 1);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          setNextCount(nextCount + 1);
        }
      }
    }
  }
  //Duplicate tokens allowed ...since one token will used for one allotment of flat only
  function getTokenDetails(eventId) {
    console.log(eventId);
    Network.getStatus().then((status) => {
      if (status.connected) {
        getLaunchSalesRelationsById(loggedInUser?.userId)
          .then((userRes) => {
            const launches = userRes?.data?.map((v) => {
              return v?.launchId;
            });
            checkTagLaunchesByLaunchId(eventId, launches)
              .then((re) => {
                const eventTokenIds = re?.data?.map((v) => {
                  return v?.eventTokenId;
                });
                getEventToken(eventId, data?.leadId, [
                  ...new Set(eventTokenIds),
                ])
                  .then((resp) => {
                    console.log("getEventToken resp", resp);
                    setTokenCount(resp.count);
                    // resp.data = resp.data.map((eachToken, index) => ({
                    // resp.data = resp.data.map((eachToken, index) => ({
                    //   ...eachToken,
                    //   index: index,
                    //   id: eachToken.tokenId.tokenId,
                    //   tokenName: eachToken.tokenId.name,
                    //   unitType: eachToken.tokenId.inventoryTypeId.type,
                    //   amount: eachToken.tokenId.amount,
                    //   isSelected: false,
                    // }));
                    const availableTokens = [];
                    resp.data.forEach((eachToken, index) => {
                      if (eachToken.tokenId) {
                        const obj = {
                          ...eachToken,
                          index: index,
                          id: eachToken.tokenId.tokenId,
                          tokenName: eachToken.tokenId.name,
                          unitType: eachToken.tokenId.inventoryTypeId.type,
                          amount: eachToken.tokenId.amount,
                          isSelected: false,
                        };
                        availableTokens.push(obj);
                      }
                    });
                    if (oldTokenData) {
                      const availableTokensNotPreselected =
                        availableTokens.filter(
                          (el) => el?.tokenId?.isPreselect === false
                        );
                      setTokenInfo(availableTokensNotPreselected);
                    } else {
                      setTokenInfo(availableTokens);
                    }
                    if (resp.count === 0) {
                      setShowNoTokens(true);
                    } else {
                      setShowNoTokens(false);
                    }
                    console.log(availableTokens);
                  })
                  .catch((err) => {
                    console.log(err);
                  });
                getAssignedToken(data?.leadId)
                  .then((resp) => {
                    console.log(resp);
                    resp = resp.map((token) => ({
                      ...token,
                      tokenName: token.eventTokenId.tokenId.name,
                    }));
                    setAlreadyHaveTokenInfo(resp);
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              })
              .catch((err) => {
                errorTost(err.message);
              });
          })
          .catch((err) => {
            errorTost(err.message);
          });
      } else {
        offlineToast();
      }
    });
  }

  function closeModal() {
    handleClose();
  }
  // function validatePatmentDetails() {
  //   var form = true;
  //   // if (paymentMethod.length === 0) {
  //   //   form = false;
  //   //   errorTost("Please Select Payment Method");
  //   // }
  //   // if (paymentMethod === "UPI" && upiUserUrl === "") {
  //   //   form = false;
  //   //   setHelperText((pre) => {
  //   //     pre.upiUrl = "Please Enter UPI";
  //   //     return { ...pre };
  //   //   });
  //   // }
  //   return {
  //     flag: form,
  //   };
  // }
  function getTodayDate() {
    var dateObj = new Date();
    var month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
    var day = dateObj.getDate().toString().padStart(2, "0");
    var year = dateObj.getUTCFullYear();
    return year.toString() + month.toString() + day.toString();
  }

  function PreSelectToken() {
    // **Checking For PreSelect
    getPreSelectInventory(assignTokenData?.selectedEventToken?.eventTokenId)
      .then((preSelectInventory) => {
        console.log(preSelectInventory);
      })
      .catch((err) => {
        console.log(err);
      });
  }
  // ??sending mail
  async function sendMailAndSms(email, subject, tokenName) {
    let message = `<h4>Hi ${data?.leadname},</h4>
    <p>${tokenName} We’re pleased to inform you that a VJ token has been successfully assigned in your name.Please log in to the VJ Customer Portal using your registered mobile number and complete the payment process to proceed further.<br> <br> VJ Customer Portal:${process.env.REACT_APP_CUSTOMER_PORTAL} </p></br>`;
    let body = {
      to: [email],
      subject: subject,
      message: message,
    };
    let messageBody = {
      number: "+" + data?.leadcontactnumber,
      message: `${tokenName} has been assigned to you successfully.Please login  ${process.env.REACT_APP_CUSTOMER_PORTAL} to complete token payment`,
      // is_international_number: true,
      is_international_number:
        data?.leadcontactnumber.toString().substring(0, 2) !== "91"
          ? true
          : false,
    };
    const sms = await sendMessage(messageBody)
      .then((resp) => {
        if (resp.data.success) {
          return true;
        } else {
          if (resp?.data?.error) {
            return false;
          }
        }
      })
      .catch((err) => {
        console.log(err.message);
        return false;
      });
    const emailRes = await sendMailTo(body)
      .then((resp) => {
        console.log(resp);
        if (resp.data.status === "err") {
          return false;
        } else {
          return true;
        }
      })
      .catch((err) => {
        console.log(err);
        return false;
      });
    return { emailRes, sms };
  }
  //  !!payment function for assign new token through global leads tab
  function paymentFunction() {
    console.log(assignTokenData);

    // let flag = validatePatmentDetails();
    // if (flag.flag) {
    Network.getStatus().then((status) => {
      if (status.connected) {
        presentLoader();
        let todaysDate = getTodayDate();
        const tokenNumber =
          assignTokenData.selectedEventToken.tokenId.shortCode +
          "-" +
          todaysDate +
          "-" +
          Math.floor(1000 + Math.random() * 9000);
        console.log({ tokenNumber });
        assignNewToken(assignTokenData, data.leadId, tokenNumber)
          .then((eventTokenLeadRelationsResp) => {
            dismissLoader();
            console.log({ eventTokenLeadRelationsResp });
            updateLeadStatus(data.leadId)
              .then(async (leadStatusResp) => {
                let obj = {
                  // cpId:data.cpid,
                  // fosId:data.fosid,
                  // userId:loggedInUser.userId,
                  leadId: data.leadId,
                  leadStatus: leadStatusResp[0].status,
                  message: `${assignTokenData?.selectedEventToken?.tokenName} assigned by ${loggedInUser.name}(${loggedInUser.roleId.title})`,
                };
                //send whatsapp message
                let whatsappToast = "";
                await sendWhatsappMessageOnAssignToken(
                  data?.leadname,
                  data?.leadcontactnumber
                )
                  .then((res) => {
                    console.log("Whatsapp response", res);
                    whatsappToast = "Whatsapp message sent successfully.";
                  })
                  .catch((err) => {
                    console.log("Whatsapp error", err);
                    whatsappToast = "Error while sending whatsapp message.";
                  });
                addLeadLogs(obj)
                  .then((leadLog) => {
                    console.log(leadLog);
                  })
                  .catch((err) => {
                    console.log("leadlog", err);
                  });

                successTost(
                  ` ${assignTokenData?.selectedEventToken?.tokenName} assigned to ${data?.leadname} successfully. ${whatsappToast}`
                );
                returnRes(true);
                closeModal();
                sendMailAndSms(
                  `${data?.leademail}`,
                  "Token Assigned Successfully",
                  assignTokenData?.selectedEventToken?.tokenName
                ).then((resp) => {
                  console.log(resp);
                  if (resp.emailRes && resp.sms) {
                    // successTost("Email and sms sent successfully");
                  } else if (resp.emailRes === false && resp.sms) {
                    // errorTost("Sms sent successfully,error while sending email ");
                  } else if (resp.emailRes && resp.sms === false) {
                    // errorTost("Email sent successfully,error while sending sms ");
                  } else {
                    // errorTost("Error while sending Email and Sms");
                  }
                });
                // let body = {
                //   leadName: data?.leadname,
                //   leadEmail: data?.leademail,
                //   leadContactNumber: data?.leadcontactnumber,
                //   leadId: data?.leadId,
                //   eventTokenId: assignTokenData.selectedEventToken.eventTokenId,
                //   eventName: assignTokenData?.event,
                //   amount: assignTokenData.selectedEventToken.tokenId.amount,
                //   tokenName: assignTokenData?.selectedEventToken?.tokenName,
                //   paymentId: eventTokenLeadRelationsResp[0].paymentId,
                //   mode: "token",
                // };
                // createPaymentLink(body)
                //   .then((resp) => {
                //     if(resp.success){
                //       // successTost("Payment Link send successfully");
                //     }else{
                //       errorTost(resp.message);
                //     }
                //   })
                //   .catch((err) => {
                //     console.log(err);
                //     dismissLoader();
                //   });
                //TokenTransactions query call
              })
              .catch((err) => {
                console.log(err);
              });
          })
          .catch((err) => {
            dismissLoader();
            console.log(err);
          });
      } else {
        offlineToast();
      }
    });
    // }
  }

  function assigningNewToken() {
    let todaysDate = getTodayDate();
    const tokenNumber =
      assignTokenData.selectedEventToken.tokenId.shortCode +
      "-" +
      todaysDate +
      "-" +
      Math.floor(1000 + Math.random() * 9000);
    console.log({ tokenNumber });
    // !!Case 1 :Old Token Amount and new Token Amount  difference is zero
    if (
      assignTokenData.selectedEventToken.amount -
        (oldTokenData.paidamount + linkedTokenData?.paidAmount ?? 0) ===
      0
    ) {
      let tokenObj = {
        eventTokenId: assignTokenData.selectedEventToken.eventTokenId,
        leadId: data.leadId,
        eventId: assignTokenData.selectedEventToken.eventId,
        amount: assignTokenData.selectedEventToken.tokenId.amount,
        paidAmount: oldTokenData.paidamount + linkedTokenData?.paidAmount ?? 0,
        tokenNumber: tokenNumber,
        status: "active",
      };
      assignNewTokenThroughPaymentTab(tokenObj)
        .then((eventTokenLeadRelationsResp) => {
          dismissLoader();
          console.log({ eventTokenLeadRelationsResp });
          updateLeadAllStatus(data.leadId, "Token Payment Complete")
            .then((leadStatusResp) => {
              // !!Update old Token Status to expired
              updateEventLeadTokenGroup(
                { status: "expired" },
                oldTokenData?.paymentid
              )
                .then((updateEventLeadRes) => {
                  // ??Priority case if linked token is also present so expiring that token too
                  if (linkedToken) {
                    updateEventLeadTokenGroup(
                      { status: "expired" },
                      linkedTokenData?.paymentId
                    ).then((updateEventLeadRes) => {});
                  }
                  let tokenTransactionObj = {
                    paymentId: eventTokenLeadRelationsResp[0].paymentId,
                  };
                  updateTokenTransaction(
                    tokenTransactionObj,
                    oldTokenData?.paymentid
                  )
                    .then((tokenTransactionRes) => {
                      //!!Updating token transaction too for linked token
                      if (linkedToken) {
                        updateTokenTransaction(
                          {
                            paymentId: eventTokenLeadRelationsResp[0].paymentId,
                          },
                          linkedTokenData?.paymentId
                        ).then((updateEventLeadRes) => {});
                      }
                      let obj = {
                        leadId: data.leadId,
                        leadStatus: "Token Payment Complete",
                        message: `${oldTokenData.tokenname} has been changed to ${assignTokenData?.selectedEventToken?.tokenName}.Action is done by ${loggedInUser.name}(${loggedInUser.roleId.title}) through Payments Tab.`,
                      };
                      addLeadLogs(obj)
                        .then((leadLog) => {
                          console.log(leadLog);
                        })
                        .catch((err) => {
                          console.log("leadlog", err);
                        });
                      successTost(
                        ` ${assignTokenData?.selectedEventToken?.tokenName} assigned to ${data?.leadname} successfully.`
                      );
                      returnRes(true);
                      closeModal();
                    })
                    .catch((tokenTransactionErr) => {
                      console.log({ tokenTransactionErr });
                    });
                })
                .catch((updateEventLeadErr) => {
                  console.log({ updateEventLeadErr });
                });
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          dismissLoader();
          console.log(err);
        });
    }
    // !!Case 2 :Old Token Amount and new Token Amount difference is greater than zero
    else if (
      assignTokenData.selectedEventToken.amount -
        (oldTokenData.paidamount + linkedTokenData?.paidAmount ?? 0) >
      0
    ) {
      let tokenObj = {
        eventTokenId: assignTokenData.selectedEventToken.eventTokenId,
        leadId: data.leadId,
        eventId: assignTokenData.selectedEventToken.eventId,
        amount: assignTokenData.selectedEventToken.tokenId.amount,
        paidAmount: oldTokenData.paidamount + linkedTokenData?.paidAmount ?? 0,
        tokenNumber: tokenNumber,
        status: "partial",
      };
      assignNewTokenThroughPaymentTab(tokenObj)
        .then((eventTokenLeadRelationsResp) => {
          dismissLoader();
          console.log({ eventTokenLeadRelationsResp });
          updateLeadAllStatus(data.leadId, "Token Partial Payment Done")
            .then((leadStatusResp) => {
              // !!Update old Token Status to expired
              updateEventLeadTokenGroup(
                { status: "expired" },
                oldTokenData?.paymentid
              )
                .then((updateEventLeadRes) => {
                  if (linkedToken) {
                    updateEventLeadTokenGroup(
                      { status: "expired" },
                      linkedTokenData?.paymentId
                    ).then((updateEventLeadRes) => {});
                  }
                  let tokenTransactionObj = {
                    paymentId: eventTokenLeadRelationsResp[0].paymentId,
                  };
                  updateTokenTransaction(
                    tokenTransactionObj,
                    oldTokenData?.paymentid
                  )
                    .then((tokenTransactionRes) => {
                      if (linkedToken) {
                        updateTokenTransaction(
                          {
                            paymentId: eventTokenLeadRelationsResp[0].paymentId,
                          },
                          linkedTokenData?.paymentId
                        ).then((updateEventLeadRes) => {});
                      }
                      let obj = {
                        leadId: data.leadId,
                        leadStatus: "Token Partial Payment Done",
                        message: `${oldTokenData.tokenname} has been changed to ${assignTokenData?.selectedEventToken?.tokenName}.Action is done by ${loggedInUser.name}(${loggedInUser.roleId.title}) through Payments Tab.`,
                      };
                      addLeadLogs(obj)
                        .then((leadLog) => {
                          console.log(leadLog);
                        })
                        .catch((err) => {
                          console.log("leadlog", err);
                        });
                      successTost(
                        ` ${assignTokenData?.selectedEventToken?.tokenName} assigned to ${data?.leadname} successfully.`
                      );
                      returnRes(true);
                      closeModal();
                    })
                    .catch((tokenTransactionErr) => {
                      console.log({ tokenTransactionErr });
                    });
                })
                .catch((updateEventLeadErr) => {
                  console.log({ updateEventLeadErr });
                });
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          dismissLoader();
          console.log(err);
        });
    }
    //!!Case 3: new Token Amount and Old Token Amount difference is less than zero then refund button will show if already brought token is refundable
  }
  return (
    <Modal
      open={open}
      onClose={(_, reason) => {
        if (reason !== "backdropClick") {
          closeModal();
        }
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(52, 64, 84, 0.7)",
          },
        },
      ]}
      disableAutoFocus={true}
    >
      <Box className={cssClasses.modalWrapper}>
        <div className={cssClasses.wrapperHeader}>
          <span className={classes.closeIcon} onClick={closeModal} tabIndex={0}>
            <Close width={"1.2rem"} height={"1.2rem"} />
          </span>
          <div>Assign New Token</div>
        </div>
        <div className={cssClasses.wrapperContent}>
          {nextCount === 0 && (
            <>
              <div className={cssClasses.wrapperBlock}>
                <div className={cssClasses.blockLabel}>
                  Select Event <span style={{ color: "red" }}> *</span>
                </div>
                <div style={{ width: "100%" }}>
                  <DropDown
                    list={EventList.map((element, id) => {
                      return {
                        label: element.title,
                        value: element.title,
                      };
                    })}
                    selectedValue={assignTokenData.event}
                    onChangeSelect={async (value) => {
                      setAssignTokenData((pre) => {
                        pre.event = value;
                        return { ...pre };
                      });

                      setHelperText((pre) => {
                        pre.event = "";
                        return { ...pre };
                      });
                      let selectedEvent;
                      selectedEvent = EventList.filter(
                        ({ title }) => value === title
                      );
                      console.log(selectedEvent);
                      setAssignTokenData((pre) => {
                        pre.preferredLocation = "";
                        pre.preferredUnitType = "";
                        return { ...pre };
                      });
                      if (selectedEvent[0].eventSiteVisit) {
                        setTokenInfo([]);
                        let Obj = { leadId: data.leadId, projects: null };
                        if (selectedEvent[0].checkProject) {
                          await getLaunchesProjects(selectedEvent[0].eventId)
                            .then((launchesProjcets) => {
                              if (launchesProjcets.length > 0) {
                                const projectIds = launchesProjcets.map(
                                  (data) => data.projectId
                                );
                                let uniqueProjectIds = [...new Set(projectIds)];
                                Obj.projects = uniqueProjectIds;
                              } else {
                                setShowErrorText({
                                  value: false,
                                  errorText: "",
                                });
                              }
                            })
                            .catch((errors) => {
                              setShowErrorText({ value: false, errorText: "" });
                              console.error("getLaunchesProjects", errors);
                            });
                        }
                        checkLeadSiteVisitAndProjects(Obj)
                          .then((leadSiteVisitDone) => {
                            if (leadSiteVisitDone.length > 0) {
                              if (
                                orderBy(leadSiteVisitDone, "created_at", [
                                  "desc",
                                ])[0].created_at >=
                                selectedEvent[0].eventSiteVisitDateTime
                              ) {
                                setShowErrorText({
                                  value: false,
                                  errorText: "",
                                });
                                getTokenDetails(selectedEvent[0].eventId);
                              } else {
                                setShowErrorText({
                                  value: true,
                                  errorText: ` No site visit found after ${new Date(
                                    selectedEvent[0].eventSiteVisitDateTime
                                  ).toDateString()} `,
                                });
                              }
                            } else {
                              setShowErrorText({
                                value: true,
                                errorText: ` No site visit found after ${new Date(
                                  selectedEvent[0].eventSiteVisitDateTime
                                ).toDateString()} `,
                              });
                            }
                          })
                          .catch((err) => {
                            setShowErrorText({ value: false, errorText: "" });
                            console.error("checkLeadSiteVisitAndProjects", err);
                          });
                      } else {
                        setShowErrorText({ value: false, errorText: "" });
                        getTokenDetails(selectedEvent[0].eventId);
                      }
                    }}
                    placeHolder={"Select"}
                    //style.color is placeHolder's color
                    style={{
                      background: "#F2F4F7",
                      color: "rgb(102, 112, 133)",
                    }}
                    helperText={helperText.event}
                  />
                </div>
              </div>
              {tokenInfo.length > 0 && (
                <div className={cssClasses.tokenTable}>
                  <div className={cssClasses.blockLabel}>
                    Select Token <span style={{ color: "red" }}> *</span>
                  </div>
                  <div className={cssClasses.wrapperTable}>
                    {tokenInfo.map((eachToken, index) => {
                      return (
                        <Card className={cssClasses.tokenCard} key={index}>
                          <div>
                            <FormControl>
                              <RadioGroup
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                                sx={{
                                  "& .MuiSvgIcon-root": {
                                    color: "#155EEF !important",
                                    fontSize: "2rem !important",
                                  },
                                }}
                                value={eachToken.isSelected}
                                onChange={(e) => {
                                  const leadType = data?.leadtype || data?.leadType;
                                  const allowedLeadTypes =
                                    eachToken?.tokenId?.allowedLeadTypes || [];
                                  if (
                                    allowedLeadTypes.length > 0 &&
                                    !allowedLeadTypes.includes(leadType)
                                  ) {
                                    errorTost(
                                      `This token is not allowed for lead type "${leadType}"`
                                    );
                                    return;
                                  }
                                  setTokenInfo((pre) => {
                                    pre = pre.map((m) => ({
                                      ...m,
                                      isSelected: false,
                                    }));
                                    console.log(pre);
                                    pre[index].isSelected = true;
                                    return [...pre];
                                  });
                                  setAssignTokenData((pre) => {
                                    pre.selectedEventToken = eachToken;
                                    pre.preferredLocation = "";
                                    pre.preferredUnitType = "";
                                    return { ...pre };
                                  });
                                  setUnitTypeList(
                                    eachToken?.tokenId?.isUnitTypeEnabled
                                      ? eachToken?.tokenId?.unitTypes || []
                                      : []
                                  );
                                  if (eachToken?.tokenId?.isLocationEnabled) {
                                    setLocationList(
                                      eachToken?.tokenId?.locations || []
                                    );
                                    setSelectPreferredLocationModal(true);
                                  } else {
                                    setLocationList([]);
                                    // Unit type is asked after location; with no location, ask it right away
                                    if (eachToken?.tokenId?.isUnitTypeEnabled) {
                                      setSelectPreferredUnitTypeModal(true);
                                    }
                                  }
                                }}
                              >
                                <FormControlLabel
                                  className={classes.radioLabel}
                                  value={true}
                                  control={<Radio />}
                                  label={
                                    <div className={classes.radioLabel}></div>
                                  }
                                />
                              </RadioGroup>
                            </FormControl>
                          </div>
                          <div className={cssClasses.labelValue}>
                            <div>
                              <span className={classes.tokenName}>
                                {eachToken.tokenName}
                              </span>
                            </div>
                            <div>
                              <span className={classes.labelValue}>
                                {eachToken.unitType}
                              </span>
                            </div>
                            <div>
                              <span className={classes.labelValue}>
                                ₹{numberWithCommas(eachToken.amount)}
                              </span>
                            </div>

                            {eachToken?.tokenId?.isPreselect && (
                              <LeadStatusChip
                                label={"Preselect"}
                                style={{
                                  color: "#B54708",
                                  backgroundColor: "#FFFAEB",
                                }}
                                icon={
                                  <Dot width={"0.5rem"} height={"0.5rem"} />
                                }
                              />
                            )}
                          </div>
                        </Card>
                      );
                    })}
                  </div>
                </div>
              )}
              {assignTokenData.preferredLocation !== "" && (
                <div className={cssClasses.locationCard}>
                  <div className={cssClasses.locationCardLabel}>
                    Preferred Location
                  </div>
                  <div className={cssClasses.locationValueRow}>
                    <span className={cssClasses.locationValueText}>
                      {assignTokenData.preferredLocation}
                    </span>
                    <span
                      className={cssClasses.changeLocationLink}
                      onClick={() => setSelectPreferredLocationModal(true)}
                    >
                      Change
                    </span>
                  </div>
                </div>
              )}
              {assignTokenData.preferredUnitType !== "" && (
                <div className={cssClasses.locationCard}>
                  <div className={cssClasses.locationCardLabel}>
                    Unit Type
                  </div>
                  <div className={cssClasses.locationValueRow}>
                    <span className={cssClasses.locationValueText}>
                      {assignTokenData.preferredUnitType}
                    </span>
                    <span
                      className={cssClasses.changeLocationLink}
                      onClick={() => setSelectPreferredUnitTypeModal(true)}
                    >
                      Change
                    </span>
                  </div>
                </div>
              )}
              {showNoTokens && (
                <div className={cssClasses.tokenTable}>
                  <div className={cssClasses.blockLabel}>
                    No Token available
                  </div>
                </div>
              )}
              {showErrorText.value && (
                <div className={cssClasses.tokenTable}>
                  <div
                    className={cssClasses.blockLabel}
                    style={{ color: "red" }}
                  >
                    {showErrorText.errorText}
                  </div>
                </div>
              )}
            </>
          )}
          {/* Assign New Token through global Leads */}
          {nextCount === 1 &&
            (oldTokenData === null || oldTokenData === undefined) && (
              <>
                <Box padding={"1rem"} textAlign={"left"}>
                  <Box>
                    <Box className={cssClasses.headerTitle} mb={2}>
                      <Card className={cssClasses.tokenCard}>
                        <div className={cssClasses.labelValue}>
                          <div>
                            <span className={classes.tokenName}>
                              {assignTokenData.selectedEventToken.tokenName}
                            </span>
                          </div>
                          <div>
                            <span className={classes.labelValue}>
                              {assignTokenData.selectedEventToken.unitType}
                            </span>
                          </div>
                          <div>
                            <span className={classes.labelValue}>
                              ₹
                              {numberWithCommas(
                                assignTokenData.selectedEventToken.amount
                              )}
                            </span>
                          </div>
                        </div>
                      </Card>
                    </Box>
                    <Box style={{ display: "flex", flexDirection: "row" }}>
                      <Box
                        className={cssClasses.subTitle}
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          columnGap: "1rem",
                          alignItems: "center",
                        }}
                      >
                        Amount to be paid :
                      </Box>
                      <Box width="300px">
                        <CustomInput
                          value={numberWithCommas(
                            assignTokenData.selectedEventToken.amount
                          )}
                          inputType={"label"}
                          position={"start"}
                          image={"true"}
                          labelText={RupeeIcon}
                          disabled={true}
                        />
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </>
            )}
          {/* Assign New Token through Payments Tab*/}
          {nextCount === 1 && oldTokenData && (
            <>
              <Box padding={"1rem"} textAlign={"left"}>
                <Box>
                  <Box className={cssClasses.headerTitle} mb={2}>
                    <Card className={cssClasses.tokenCard}>
                      <div className={cssClasses.labelValue}>
                        <div>
                          <span className={classes.tokenName}>
                            {assignTokenData.selectedEventToken.tokenName}
                          </span>
                        </div>
                        <div>
                          <span className={classes.labelValue}>
                            {assignTokenData.selectedEventToken.unitType}
                          </span>
                        </div>
                        <div>
                          <span className={classes.labelValue}>
                            ₹
                            {numberWithCommas(
                              assignTokenData.selectedEventToken.amount
                            )}
                          </span>
                        </div>
                      </div>
                    </Card>
                  </Box>
                  {/* Case:1 When old token Amount Paid is less than new token Amount */}
                  <div className={cssClasses.block1}>
                    <span className={cssClasses.blockLabel}>
                      Balance Amount:
                    </span>

                    <span className={cssClasses.blockLabel}>
                      ₹{" "}
                      {numberWithCommas(
                        oldTokenData.paidamount + linkedTokenData?.paidAmount ??
                          0
                      )}
                    </span>
                  </div>
                  <div className={cssClasses.block1}>
                    <span className={cssClasses.blockLabel}>New Amount</span>

                    <span className={cssClasses.blockLabel}>
                      ₹{" "}
                      {numberWithCommas(
                        assignTokenData.selectedEventToken.amount
                      )}
                    </span>
                  </div>
                  {assignTokenData.selectedEventToken.amount -
                    (oldTokenData.paidamount + linkedTokenData?.paidAmount ??
                      0) >=
                  0 ? (
                    <div className={cssClasses.block1}>
                      <span className={cssClasses.blockLabel}>
                        Difference in Token Amount:
                      </span>

                      <span className={cssClasses.blockLabel}>
                        ₹{" "}
                        {numberWithCommas(
                          assignTokenData.selectedEventToken.amount -
                            (oldTokenData.paidamount +
                              linkedTokenData?.paidAmount ?? 0)
                        )}
                      </span>
                    </div>
                  ) : (
                    <div className={cssClasses.block1}>
                      {oldTokenData?.refundable && !linkedToken && (
                        <span
                          className={cssClasses.blockLabel}
                          style={{
                            color: "red",
                          }}
                        >
                          You cannot Buy this token as balance amount is greater
                          than current token amount.You can refund your token
                          first.
                        </span>
                      )}
                      {!oldTokenData?.refundable && !linkedToken && (
                        <span
                          className={cssClasses.blockLabel}
                          style={{
                            color: "red",
                          }}
                        >
                          You cannot Buy this token as balance amount is greater
                          than current token amount and current token is not
                          refundable.
                        </span>
                      )}
                      {linkedToken && (
                        <div>
                          <span
                            className={cssClasses.blockLabel}
                            style={{
                              color: "red",
                            }}
                          >
                            You cannot buy this token as the balance amount is
                            greater than current token amount.
                            {!oldTokenData?.refundable &&
                            !linkedTokenData?.eventTokenId?.tokenId
                              ?.isRefundable
                              ? "You cannot refund your token."
                              : "You can refund your token."}
                          </span>
                          <div
                            className={cssClasses.blockLabel}
                            style={{
                              marginBottom: "0.5rem",
                              marginTop: "0.5rem",
                            }}
                          >
                            {oldTokenData?.tokenname}(
                            {oldTokenData?.tokennumber}) is{" "}
                            {oldTokenData?.refundable
                              ? "Refundable"
                              : "Non Refundable"}
                          </div>
                          <div className={cssClasses.blockLabel}>
                            {linkedTokenData?.eventTokenId?.tokenId?.name}(
                            {linkedTokenData?.tokenNumber}) is{" "}
                            {linkedTokenData?.eventTokenId?.tokenId
                              ?.isRefundable
                              ? "Refundable"
                              : "Non Refundable"}
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  {assignTokenData.selectedEventToken.amount -
                    (oldTokenData.paidamount + linkedTokenData?.paidAmount ??
                      0) >=
                    0 && (
                    <Box style={{ display: "flex", flexDirection: "row" }}>
                      <Box
                        className={cssClasses.subTitle}
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          columnGap: "1rem",
                          alignItems: "center",
                        }}
                      >
                        Amount to be paid :
                      </Box>
                      <Box width="300px">
                        <CustomInput
                          value={numberWithCommas(
                            assignTokenData.selectedEventToken.amount -
                              (oldTokenData.paidamount +
                                linkedTokenData?.paidAmount)
                          )}
                          inputType={"label"}
                          position={"start"}
                          image={"true"}
                          labelText={RupeeIcon}
                          disabled={true}
                        />
                      </Box>
                    </Box>
                  )}
                </Box>
              </Box>
            </>
          )}
        </div>
        <div className={cssClasses.wrapperFooter}>
          <div>
            <Button
              style={{
                color: "#344054",
                backgroundColor: "#ffffff",
                fontSize: "1.6rem",
                lineHeight: "2.4rem",
              }}
              btnName={nextCount === 0 ? "Cancel" : "Back"}
              clicked={() => {
                //
                if (nextCount === 0) {
                  closeModal();
                } else {
                  setNextCount(nextCount - 1);
                }
              }}
            />
          </div>
          <div>
            <Button
              style={{
                color: "#ffffff",
                backgroundColor: "#155EEF",
                fontSize: "1.6rem",
                lineHeight: "2.4rem",
              }}
              btnName={nextCount === 0 ? "Next" : "Done"}
              clicked={() => {
                console.log("next clicked and count is ", nextCount);
                if (nextCount === 0) {
                  console.log("showNoTokens value is ", showNoTokens );
                  if (showNoTokens === false) {
                    checkAllFieldsAreFilled();
                  }
                } else if (nextCount === 1) {
                console.log("next clicked and count is ", nextCount);

                  // !!Assign new token through payments tab
                  if (oldTokenData) {
                    console.log("Assign new token through payments tab");
                    console.log({ assignTokenData });
                    assigningNewToken();
                  } else {
                    console.log("else part called");
                    paymentFunction();
                  }
                }
              }}
              disable={
                nextCount === 1 &&
                (oldTokenData !== null || oldTokenData !== undefined) &&
                assignTokenData.selectedEventToken.amount -
                  (oldTokenData?.paidamount + linkedTokenData?.paidAmount ??
                    0) <
                  0
              }
            />
          </div>
          {nextCount === 1 &&
            !linkedToken &&
            (oldTokenData !== null || oldTokenData !== undefined) &&
            oldTokenData?.refundable &&
            assignTokenData.selectedEventToken.amount -
              (oldTokenData?.paidamount + linkedTokenData?.paidAmount ?? 0) <
              0 && (
              <div>
                <Button
                  style={{
                    color: "#ffffff",
                    backgroundColor: "#155EEF",
                    fontSize: "1.6rem",
                    lineHeight: "2.4rem",
                  }}
                  btnName={"Refund Token"}
                  clicked={() => {
                    let obj = {
                      TokenRefundRequests: oldTokenData.TokenRefundRequests,
                      amount: oldTokenData.amount,
                      paymentId: oldTokenData.paymentid,
                      tokenName: oldTokenData.tokenname,
                      eventTokenId: {
                        tokenId: {
                          amount: {
                            isRefundable: oldTokenData.refundable,
                          },
                          inventoryTypeId: {
                            type: oldTokenData.unittype,
                          },
                        },
                      },
                    };
                    setRefundTokenData(obj);
                    setRefundTokenModal(true);
                  }}
                />
              </div>
            )}
        </div>
        {refundTokenModal && (
          <RefundToken
            open={refundTokenModal}
            handleClose={() => {
              setRefundTokenModal(false);
            }}
            refundTokenData={refundTokenData}
            data={data}
            returnRes={(value) => {
              if (value) {
                returnRes(true);
                closeModal();
                handleClose();
              }
            }}
          />
        )}
        {selectPreferredLocationModal && (
          <SelectPreferredLocation
            open={selectPreferredLocationModal}
            handleClose={() => {
              setSelectPreferredLocationModal(false);
            }}
            locationList={locationList}
            returnRes={(location) => {
              const isFirstSelection = !assignTokenData.preferredLocation;
              setAssignTokenData((pre) => {
                pre.preferredLocation = location;
                return { ...pre };
              });
              // After location is picked, ask for unit type (only on first pick, not on "Change")
              if (
                isFirstSelection &&
                assignTokenData.selectedEventToken?.tokenId?.isUnitTypeEnabled &&
                !assignTokenData.preferredUnitType
              ) {
                setSelectPreferredUnitTypeModal(true);
              }
            }}
          />
        )}
        {selectPreferredUnitTypeModal && (
          <SelectPreferredLocation
            open={selectPreferredUnitTypeModal}
            handleClose={() => {
              setSelectPreferredUnitTypeModal(false);
            }}
            locationList={unitTypeList}
            title={"Select Unit Type"}
            label={"Unit Type"}
            placeHolder={"Select Unit Type"}
            returnRes={(unitType) => {
              setAssignTokenData((pre) => {
                pre.preferredUnitType = unitType;
                return { ...pre };
              });
            }}
          />
        )}
      </Box>
    </Modal>
  );
}
